import { render } from "./desktop_nav.vue?vue&type=template&id=5dbfe449"
import script from "./desktop_nav.js?vue&type=script&lang=js"
export * from "./desktop_nav.js?vue&type=script&lang=js"

import "./desktop_nav.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__